(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (function () {
  var CONTENT_SELECTOR = '.blog-post-content';
  var SWIPE_THRESHOLD = 40;

  var lb = null, lbImg = null, lbPrev = null, lbNext = null, lbCounter = null;
  var lbList = [], lbIndex = 0, lastFocused = null, savedOverflow = '';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function init(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    var contents = scope.querySelectorAll(CONTENT_SELECTOR);
    for (var i = 0; i < contents.length; i++) buildGalleries(contents[i]);
  }

  function buildGalleries(content) {
    if (content.dataset.galleryReady === 'true') return;      // 防重复初始化
    content.dataset.galleryReady = 'true';
    if (content.dataset.gallery === 'false') return;          // 后台关闭画廊
    processLevel(content, 0);
  }

  /* 逐层扫描：先合并本层「连续的纯图片区块」，再下钻到包裹层。
     article.content 常被 <rte-formatter>（或主题自定义的 <div class="rte">）
     整包住，只扫 .blog-post-content 的直接子元素会一张图都碰不到。 */
  function processLevel(container, depth) {
    if (depth > 5) return;

    var runs = [];
    var current = [];
    var blanks = [];               // 图片之间的空段落（RTE 很爱插），不打断连续性
    var children = Array.prototype.slice.call(container.children);

    children.forEach(function (child) {
      if (isBlankBlock(child)) { blanks.push(child); return; }

      var imgs = collectImageBlock(child);
      if (imgs && imgs.length) {
        blanks.forEach(function (b) { current.push({ el: b, imgs: [] }); });
        blanks = [];
        current.push({ el: child, imgs: imgs });
      } else {
        flushRun();
      }
    });
    flushRun();

    function flushRun() {
      if (current.length) runs.push(current);
      current = [];
      blanks = [];
    }

    runs.forEach(function (run) {
      var imgs = [];
      run.forEach(function (item) { imgs = imgs.concat(item.imgs); });
      if (imgs.length < 2) return;   // 单张图保持原样
      createGallery(run, imgs);
    });

    /* 下钻：只进块级容器和自定义元素（rte-formatter 之类） */
    Array.prototype.slice.call(container.children).forEach(function (child) {
      if (child.classList && child.classList.contains('image-gallery')) return;
      if (!BLOCK_TAGS[child.tagName] && child.tagName.indexOf('-') === -1) return;
      processLevel(child, depth + 1);
    });
  }

  var BLOCK_TAGS = {
    DIV: 1, P: 1, FIGURE: 1, SECTION: 1, ARTICLE: 1,
    MAIN: 1, LI: 1, BLOCKQUOTE: 1, TD: 1, ASIDE: 1
  };

  /* 空白块：没有文字、最多只有 <br> */
  function isBlankBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName === 'BR') return true;
    var i;
    for (i = 0; i < el.children.length; i++) {
      if (el.children[i].tagName !== 'BR') return false;
    }
    var text = (el.textContent || '').replace(/\u00a0/g, ' ');
    return text.trim() === '';
  }

  /* 递归收集：整块只由图片（或 <a><img></a>）构成才返回数组，否则返回 null */
  function collectImageBlock(el) {
    var out = [];
    return walk(el, out) ? out : null;
  }

  function walk(el, out) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;

    if (tag === 'IMG') { out.push(el); return true; }

    if (tag === 'BR') return true;   // RTE 常在图片后面插 <br>，别让它打断识别

    if (tag === 'A') {
      if (el.children.length === 1 && el.firstElementChild.tagName === 'IMG') {
        out.push(el.firstElementChild);
        return true;
      }
      return false;
    }

    if (tag === 'P' || tag === 'DIV' || tag === 'FIGURE' || tag === 'SPAN') {
      var nodes = el.childNodes, i;
      for (i = 0; i < nodes.length; i++) {                 // 有文字就不算纯图片块
        if (nodes[i].nodeType === 3 && nodes[i].textContent.trim() !== '') return false;
      }
      if (!el.children.length) return false;
      for (i = 0; i < el.children.length; i++) {
        if (!walk(el.children[i], out)) return false;
      }
      return out.length > 0;
    }
    return false;
  }

  /* ---------- 画廊 ---------- */
  function createGallery(run, imgs) {
    var data = imgs.map(function (img) {
      return {
        src: img.currentSrc || img.src,
        srcset: img.getAttribute('srcset') || '',   // 保留主题的响应式尺寸
        sizes: img.getAttribute('sizes') || '',
        alt: img.alt || ''
      };
    });

    var gallery = document.createElement('div');
    gallery.className = 'image-gallery';
    gallery.setAttribute('data-count', data.length);
    gallery.setAttribute('role', 'group');
    gallery.setAttribute('aria-roledescription', 'carousel');
    gallery.setAttribute('aria-label', 'Image gallery');
    gallery.setAttribute('tabindex', '0');

    var main = document.createElement('div');
    main.className = 'image-gallery__main';

    var mainImg = document.createElement('img');
    mainImg.className = 'image-gallery__image';
    mainImg.decoding = 'async';
    applyImage(mainImg, data[0]);
    main.appendChild(mainImg);

    var prevBtn = makeBtn('image-gallery__nav image-gallery__nav--prev', '‹', 'Previous image');
    var nextBtn = makeBtn('image-gallery__nav image-gallery__nav--next', '›', 'Next image');
    main.appendChild(prevBtn);
    main.appendChild(nextBtn);

    var counter = document.createElement('div');
    counter.className = 'image-gallery__counter';
    counter.setAttribute('aria-live', 'polite');
    main.appendChild(counter);

    gallery.appendChild(main);

    var thumbs = document.createElement('div');
    thumbs.className = 'image-gallery__thumbs';
    var thumbBtns = [];
    data.forEach(function (d, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'image-gallery__thumb';
      btn.setAttribute('aria-label', 'Show image ' + (i + 1));
      var t = document.createElement('img');
      t.src = d.src;
      t.alt = d.alt;
      t.loading = 'lazy';
      t.decoding = 'async';
      btn.appendChild(t);
      btn.addEventListener('click', function () { goTo(i); });
      thumbs.appendChild(btn);
      thumbBtns.push(btn);
    });
    gallery.appendChild(thumbs);

    var current = 0;

    function goTo(index) {
      current = (index + data.length) % data.length;
      applyImage(mainImg, data[current]);
      thumbBtns.forEach(function (btn, i) {
        var on = i === current;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && btn.scrollIntoView) {
          btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
      counter.textContent = (current + 1) + ' / ' + data.length;
    }

    prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); });
    mainImg.addEventListener('click', function () { openLightbox(data, current); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(data, current); }
    });

    /* 移动端左右滑动 */
    var startX = 0, startY = 0;
    main.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        goTo(current + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    goTo(0);

    var anchor = run[0].el;
    anchor.parentNode.insertBefore(gallery, anchor);
    run.forEach(function (item) { if (item.el.parentNode) item.el.remove(); });
  }

  /* sizesOverride：灯箱里要用灯箱自己的宽度，否则会选中正文尺寸的小图 */
  function applyImage(el, d, sizesOverride) {
    if (d.srcset) { el.srcset = d.srcset; } else { el.removeAttribute('srcset'); }
    var sizes = sizesOverride || d.sizes;
    if (sizes) { el.sizes = sizes; } else { el.removeAttribute('sizes'); }
    el.src = d.src;
    el.alt = d.alt;
  }

  function makeBtn(className, html, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = className;
    b.innerHTML = html;
    b.setAttribute('aria-label', label);
    return b;
  }

  /* ---------- 灯箱 ---------- */
  function ensureLightbox() {
    if (lb) return;

    lb = document.createElement('div');
    lb.className = 'image-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image viewer');
    lb.tabIndex = -1;                 // 没有 tabindex 的话 lb.focus() 不生效

    lbImg = document.createElement('img');
    lb.appendChild(lbImg);

    lbPrev = makeBtn('image-lightbox__btn image-lightbox__btn--prev', '‹', 'Previous image');
    lbNext = makeBtn('image-lightbox__btn image-lightbox__btn--next', '›', 'Next image');
    var close = makeBtn('image-lightbox__btn image-lightbox__btn--close', '✕', 'Close');

    lbCounter = document.createElement('div');
    lbCounter.className = 'image-lightbox__counter';

    lb.appendChild(lbPrev);
    lb.appendChild(lbNext);
    lb.appendChild(close);
    lb.appendChild(lbCounter);

    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLightbox();
    });
    close.addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbIndex - 1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbIndex + 1); });

    document.body.appendChild(lb);
  }

  function openLightbox(list, index) {
    ensureLightbox();
    lbList = list;
    lbIndex = index;
    lastFocused = document.activeElement;
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    lb.setAttribute('data-count', list.length);
    lb.classList.add('is-open');
    showLb(index);
    lb.focus();
  }

  function showLb(index) {
    if (!lbList.length) return;
    lbIndex = (index + lbList.length) % lbList.length;
    applyImage(lbImg, lbList[lbIndex], '92vw');
    lbCounter.textContent = (lbIndex + 1) + ' / ' + lbList.length;
  }

  function closeLightbox() {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open');
    document.body.style.overflow = savedOverflow;
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
    if (e.key === 'ArrowRight') showLb(lbIndex + 1);
  });

  /* ---------- 启动 ---------- */
  ready(function () {
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) { init(e.target); });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('contact-form-effects')) {
    customElements.define(
      'contact-form-effects',
      class ContactFormEffects extends HTMLElement {
        connectedCallback() {
          if (this.dataset.pointerGlow !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.pointerX = 0;
          this.pointerY = 0;
          this.frame = null;

          this.handlePointerMove = (event) => {
            this.pointerX = event.clientX;
            this.pointerY = event.clientY;

            if (this.frame) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              const rect = this.getBoundingClientRect();
              this.style.setProperty('--cf-pointer-x', `${this.pointerX - rect.left}px`);
              this.style.setProperty('--cf-pointer-y', `${this.pointerY - rect.top}px`);
            });
          };

          this.addEventListener('pointermove', this.handlePointerMove, { passive: true });
        }

        disconnectedCallback() {
          if (this.handlePointerMove) {
            this.removeEventListener('pointermove', this.handlePointerMove);
          }
          if (this.frame) cancelAnimationFrame(this.frame);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
